
export function InlineIcon({ icon, label }: { icon: string; label: string }) {
    return <span className="material-icons md-16 rc-inline-icon" aria-label={label} title={label}>{icon}</span>;
}

export function IconAction({ label, icon = "delete", onClick }: { label: string; icon?: string; onClick: () => void }) {
    return (
        <button className="rc-iconbtn muted" type="button" aria-label={label} title={label} onClick={onClick}>
            <span className="material-icons md-16" aria-hidden="true">{icon}</span>
        </button>
    );
}

export function StatusIcon({ ready }: { ready: boolean }) {
    return (
        <span
            className={ready ? "rc-status-icon ready" : "rc-status-icon draft"}
            title={ready ? "Included in SQL and preview." : "Draft. Complete the required fields to include it in SQL and preview."}
            aria-label={ready ? "Ready" : "Draft"}
            role="img"
        >
            <span className="material-icons md-16" aria-hidden="true">{ready ? "check_circle" : "pending"}</span>
        </span>
    );
}